var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.01212 3.5233L4.01212 6.07784L8.01212 8.63239L4.01212 11.1869L0 8.60814L4.00909 6.0536L0 3.5233L4.00909 0.96875L8.01212 3.5233ZM3.98788 11.99L7.98788 9.43542L11.9879 11.99L7.98788 14.5445L3.98788 11.99ZM8.01212 8.60814L12.0121 6.0536L8.01212 3.52027L11.9909 0.96875L16 3.5233L11.9909 6.07784L16 8.62936L11.9909 11.1839L8.01212 8.60814Z","fill":"#1F1F1F"}));
}

Download.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = Download;

Download.default = Download;
